import restApi from '@/utils/rest-api'

export default {
    awardBadgeForMission(missionId) {
        return restApi.post(`badges/award-for-mission/${missionId}`)
    }
}
